import { gql } from '@apollo/client';

/**
 * Mutation to update an existing rule
 */
export const UPDATE_RULE_MUTATION = gql`
  mutation UpdateRule($ruleId: ID!, $input: UpdateRuleInput!) {
    updateRule(ruleId: $ruleId, input: $input) {
      success
      message
      ruleId
      rule {
        ruleId
        name
        ruleStatus
        approvalStatus
        priority
        redirectUrl
        ruleStartFrom
        ruleEndAt
        boundingBox {
          west
          east
          south
          north
        }
        countries
        categories
        divisions
        gtins
        qrs
        styleColorCodes
        styleCodes
        updatedBy
        updatedAt
      }
      pendingChangesInfo {
        operationType
        requestedBy
        requestedAt
        changes
      }
    }
  }
`;

/**
 * Mutation to delete a rule
 */
export const DELETE_RULE_MUTATION = gql`
  mutation DeleteRule($ruleId: ID!) {
    deleteRule(ruleId: $ruleId) {
      success
      message
      ruleId
    }
  }
`;

/**
 * Mutation to process approval (approve or reject)
 */
export const PROCESS_APPROVAL_MUTATION = gql`
  mutation ProcessApproval($ruleId: ID!, $action: ApprovalActionEnum!, $comment: String) {
    processApproval(ruleId: $ruleId, action: $action, comment: $comment) {
      success
      message
      rule {
        ruleId
        name
        approvalStatus
        ruleStatus
        approvedBy
        approvedAt
        rejectedBy
        rejectedAt
        rejectionReason
      }
    }
  }
`;

/**
 * Mutation to cancel pending changes
 */
export const CANCEL_PENDING_CHANGES_MUTATION = gql`
  mutation CancelPendingChanges($ruleId: ID!) {
    cancelPendingChanges(ruleId: $ruleId) {
      success
      message
      rule {
        ruleId
        name
        approvalStatus
        ruleStatus
        pendingChanges {
          operationType
          requestedBy
          requestedAt
        }
      }
    }
  }
`;
